/** Ensure the values match the note types specified in notes.sql */
export const usedNoteTypes = [
  'PAR', // Parties
  'PRO', // Properties
  'RAC', // Rents
  'TCY', // Tenancies
  'APP', // Applications
  'ACA', // Arrears Actions
  'SRQ', // Service Requests
  'INS', // Inspections
  'WOR', // Works Orders
] as const;

export const noteCautionSubtype = 'CAUTION';
export const noteFireSafetySubtype = 'FIRESAFETY';
